export default "__VITE_ASSET__BDM1GLo$__"